/** Fetches offset-based pages sequentially until the final, partial page. */
export async function fetchAll<T>(
	fetchPage: (params: { limit: number; offset: number }) => Promise<readonly T[]>,
	limit: number,
): Promise<T[]> {
	if (!Number.isSafeInteger(limit) || limit <= 0) {
		throw new RangeError('Page limit must be a positive integer');
	}

	const items: T[] = [];

	for (;;) {
		const page = await fetchPage({ limit, offset: items.length });
		items.push(...page);
		if (page.length < limit) return items;
	}
}
